import styled from "@emotion/styled"

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10rem;
`
